function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "slf6a",
  d: "M1037.862 320.246v-.492c0-1.016-1.596-1.016-1.596 0v.492c-5.054-.394-9.077-4.36-9.476-9.344h.466c1.064 0 1.064-1.607 0-1.607h-.466c.4-4.984 4.422-8.95 9.476-9.344v.492c0 1.016 1.596 1.016 1.596 0v-.492c5.087.393 9.11 4.36 9.509 9.377h-.499c-1.064 0-1.064 1.574 0 1.574h.499c-.4 4.983-4.422 8.95-9.51 9.344zm-3.89-7.77l3.524-1.804a.82.82 0 0 0 .4-.721v-6.066c0-1.049-1.597-1.049-1.597 0v5.607l-3.059 1.574c-.93.491-.2 1.868.732 1.41zm3.956-15.902h1.696c.133 0 .266-.131.266-.263v-1.049a.26.26 0 0 0-.266-.262h-5.02a.26.26 0 0 0-.266.262v1.05c0 .13.133.262.266.262h1.728v1.803c-6.25.393-11.17 5.475-11.17 11.738 0 6.492 5.319 11.737 11.902 11.737 6.583 0 11.936-5.245 11.936-11.737 0-6.23-4.887-11.312-11.072-11.738z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-1025 -295)"
}, React.createElement("use", {
  xlinkHref: "#slf6a"
})));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Clock.4fa50638.svg";
export { ForwardRef as ReactComponent };